import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/icon/bus-outline-blue-default.svg'
import _imports_1 from '@/assets/img/icon/delete-box-red.svg'
import _imports_2 from '@/assets/img/icon/snack-outline-blue.svg'
import _imports_3 from '@/assets/img/modal-confirmation/snack-empty.svg'


const _hoisted_1 = {
  key: 0,
  class: "roster-snack-form"
}
const _hoisted_2 = {
  class: "xl:flex gap-3",
  style: {"height":"auto","min-height":"45vh"}
}
const _hoisted_3 = { class: "w-full xl:w-3/4 mb-2 xl:mb-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-3 mb-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "bus",
    style: {"width":"32px"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Informasi Keberangkatan")
], -1)
const _hoisted_5 = { class: "mb-4 pb-4 border-bottom-grey-3" }
const _hoisted_6 = { class: "md:flex items-center gap-1 mb-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/5 text-grey text-sm" }, "Nopol", -1)
const _hoisted_8 = { class: "w-4/5 text-sm" }
const _hoisted_9 = { class: "md:flex items-center gap-1 mb-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/5 text-grey text-sm" }, "Nama Trayek", -1)
const _hoisted_11 = { class: "w-4/5 text-sm" }
const _hoisted_12 = { class: "md:flex items-center gap-1 mb-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/5 text-grey text-sm" }, "Nama PP / Jam", -1)
const _hoisted_14 = { class: "w-4/5 text-sm" }
const _hoisted_15 = { class: "md:flex gap-30px mb-5" }
const _hoisted_16 = { class: "w-full md:w-1/4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-semibold" }, "Gudang Asal", -1)
const _hoisted_18 = {
  key: 0,
  class: "text-sm text-grey"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "flex-1 w-full snack-form md:w-3/4"
}
const _hoisted_21 = {
  key: 0,
  class: "md:flex gap-30px overflow-y-scroll"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-1/4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-semibold" }, "Snack yang Dibawa"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-grey" }, "Tentukan yang akan dibawa oleh kondektur di perjalanan")
], -1)
const _hoisted_23 = {
  class: "flex-1 w-full md:w-3/4",
  style: {"height":"auto","min-height":"44vh"}
}
const _hoisted_24 = { class: "flex items-center gap-2 mb-3" }
const _hoisted_25 = { class: "w-3/4" }
const _hoisted_26 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "text-base font-bold" }
const _hoisted_29 = { class: "text-sm desc" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "flex items-center gap-2" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "text-base font-bold" }
const _hoisted_34 = { class: "text-sm desc" }
const _hoisted_35 = { class: "w-1/4" }
const _hoisted_36 = { class: "p-inputgroup flex-1" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Pack", -1)
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "mt-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Tambah Item'), -1)
const _hoisted_41 = { class: "w-full xl:w-1/4" }
const _hoisted_42 = { class: "flex flex-col h-full" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "snack",
    style: {"width":"32px"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Snack")
], -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 pb-2 border-bottom-grey-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, "Daftar Snack yang Dibawa Kondektur")
], -1)
const _hoisted_45 = { key: 0 }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "img",
  class: "my-3 mx-auto"
}, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-center" }, "Oops, kamu belum mengatur snack yang akan dibawa Kondektur!", -1)
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = { key: 1 }
const _hoisted_50 = {
  class: "flex-1 overflow-y-scroll",
  style: {"height":"57vh"}
}
const _hoisted_51 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_52 = { class: "mb-3 flex items-center gap-3" }
const _hoisted_53 = ["src"]
const _hoisted_54 = { class: "grow-3" }
const _hoisted_55 = { class: "text-sm font-bold" }
const _hoisted_56 = { class: "text-xs" }
const _hoisted_57 = { class: "text-sm font-bold" }
const _hoisted_58 = { class: "pt-4 border-top-grey-3 mt-auto flex items-center justify-between" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Total Snack", -1)
const _hoisted_60 = { class: "text-sm" }
const _hoisted_61 = { class: "text-xl font-bold" }
const _hoisted_62 = { class: "flex items-center justify-end mt-4" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_64 = /*#__PURE__*/_createTextVNode("Simpan")

import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { onMounted, ref, getCurrentInstance, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Card from 'primevue/card'
import Dropdown from 'primevue/dropdown'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import numberFormat from '@/utils/helpers/numberFormat'
import { Form, Field, FieldArray, ErrorMessage, useForm } from 'vee-validate'
import * as Yup from 'yup'
import Button from 'primevue/button'
import SelectAsyncWithImage from '@/views/components/form/SelectAsyncWithImage.vue'
import InputNumber from 'primevue/inputnumber'
import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import apiUseCase from '@/usecase/apiUseCase'
import SelectAsyncOpen from '@/views/components/form/SelectAsyncOpen.vue'
import moment from 'moment'
import environment from '@/configs/environtment'
import changeImagePathPrefix from '@/utils/helpers/changeImagePathPrefix'
import defaulListImage from '@/assets/img/icon/cross-black-background-grey.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'RosterSnackForm',
  setup(__props) {

const endpoint = '/ticket/v1/Snacks'
const store = useStore()
const route = useRoute()
const router = useRouter()
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const dataHeader = ref(null) as any
const snackList = ref([]) as any
// const totalPrice = ref(0)
// const totalQty = ref(0)
const dataForm = ref()
const isRoster = ref(false)
const isLoading = ref(true)
const isShowFormList = ref(false)
const rosterSnackData = ref()
const rosterSnackList = ref([]) as any
const snackListByBuilding = ref([]) as any

const defaultList = () => ({
  snackData: null,
  qty: 0
})

const initialValues = {
  buildingData: null as any,
  data: [] as any
}

const schema = Yup.object().shape({
  buildingData: Yup.object().required('Pilih Gedung terlebih dahulu'),
  data: Yup.array().of(
    Yup.object().shape({
      snackData: Yup.object().required('Snack tidak boleh kosong'),
      qty: Yup.number()
        .test('max-stock', 'qty melebihi stok yang tersedia', (val, context) => {
          const snackStock = context?.parent?.snackData?.SnackStock ?? 0
          console.log('snackStock', snackStock)
          if (!val) return true
          return val <= snackStock
        })
    })
  )
})

const { values, errors, setFieldValue, handleSubmit, resetForm } = useForm({
  initialValues,
  validationSchema: schema
})

// eslint-disable-next-line arrow-body-style
const selectedSnackIds = computed(() => {
  return values.data
    ?.map((x: any) => x?.snackData?.SnackId || x?.snackData?.value)
    .filter(Boolean)
})

const totalQty = computed(() => (values.data || []).reduce((acc: number, item: any) => acc + (item?.qty || 0), 0))

const totalPrice = computed(() => (values.data || []).reduce((acc: number, item: any) => {
  const price = item?.snackData?.SnackPrice || 0
  const qty = item?.qty || 0
  return acc + price * qty
}, 0))

const processSubmit = async () => {
  console.log('data', dataForm.value)
  store.dispatch('showLoading')
  const payload = {
    FromBuildingId: dataForm.value.buildingData?.id,
    FromBuildingName: dataForm.value.buildingData?.name,
    ToBuildingId: null,
    ToBuildingName: null,
    ReferenceId: dataHeader.value.Id,
    TransferType: 'AssignToRoster',
    SnackTransferItems: [] as any
  }

  // eslint-disable-next-line no-unused-expressions, array-callback-return
  dataForm.value?.data.map((data: any) => {
    const obj = {
      SnackId: data.snackData?.SnackId,
      Quantity: data.qty
    }
    payload.SnackTransferItems.push(obj)
  })
  // console.log('payload', payload)
  try {
    await apiOpenUseCase.postWithNoId(`${endpoint}/Transfer`, payload).then((response) => {
      const { result, error, message } = response
      if (!error) {
        $toast.add({
          severity: 'success',
          detail: 'Snack berhasil disimpan',
          group: 'bc',
          life: 3000
        })
        // eslint-disable-next-line no-use-before-define
        toPrevPage()
      } else {
        $toast.add({
          severity: 'error',
          summary: 'Gagal menyimpan snack',
          detail: message,
          group: 'bc',
          life: 3000
        })
      }
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: 'Gagal menyimpan snack',
      detail: error,
      group: 'bc',
      life: 3000
    })
  }
  store.dispatch('hideLoading')
}

const onSubmit = handleSubmit((val: any) => {
  // console.log('submit', val)
  if (val.data.length > 0 && val.data[0]?.snackData) {
    dataForm.value = val
    processSubmit()
  } else {
    $toast.add({
      severity: 'error',
      detail: 'Snack yang dibawa minimal 1',
      group: 'bc',
      life: 3000
    })
  }
})

const toPrevPage = () => {
  router.push({
    name: 'roster'
  })
}

const isSelectable = (option: any, currentIndex: number) => {
  // eslint-disable-next-line operator-linebreak
  const currentId =
    // eslint-disable-next-line operator-linebreak
    values.data?.[currentIndex]?.snackData?.SnackId ||
    values.data?.[currentIndex]?.snackData?.value

  const allSelected = values.data
    ?.map((x: any) => x?.snackData?.SnackId || x?.snackData?.value)
    .filter(Boolean)

  // hapus id milik row ini sendiri
  const otherSelected = allSelected.filter((id: any) => id !== currentId)

  return !otherSelected.includes(option.value)
}

watch(
  () => values.buildingData?.id,
  (newId, oldId) => {
    if (newId && newId !== oldId) {
      isShowFormList.value = false
      setFieldValue('data', [])
      snackListByBuilding.value = []
      setTimeout(() => {
        isShowFormList.value = true
      }, 100)
    }
  }
)

watch(() => values.buildingData?.id, (newValue) => {
  console.log('newVal', newValue)
  // eslint-disable-next-line no-use-before-define
  getAllSnackDataByBuildingId()
})

const setBuildingData = async () => {
  store.dispatch('showLoading')
  // await Promise.all([
  //   store.dispatch('userProfiles/fetchUserEmploymentAndBuilding')
  // ])
  const building = await store.dispatch('userProfiles/fetchUserEmploymentAndBuilding')
  // console.log('building', store.state.userProfiles.building)
  resetForm({
    values: {
      buildingData: { label: building?.name, ...building },
      data: []
    }
  })
  isLoading.value = false
  store.dispatch('hideLoading')
}

const checkAssignedSnack = () => {
  store.dispatch('showLoading')
  apiOpenUseCase.get(`${endpoint}/Transfer/ByReference/${dataHeader.value.Id}`).then((response) => {
    // console.log('snackList', response.result)
    const { result, error } = response
    if (!error) {
      rosterSnackData.value = result
      rosterSnackList.value = result.SnackTransferItems.map((data: any) => ({
        ...data,
        Image: data.SnackImage ? `${environment.getApiImageBaseUrl()}${changeImagePathPrefix(data.SnackImage)}` : defaulListImage,
      }))
    }
  })
  store.dispatch('hideLoading')
}

const getAllSnackDataByBuildingId = async () => {
  store.dispatch('showLoading')
  try {
    snackListByBuilding.value = []
    const response = await apiOpenUseCase.get(`${endpoint}/ByBuilding/${values.buildingData?.id}`)
    // console.log('response', response)
    if (!response.error) {
      const dataTemp = response.result.filter((data: any) => data.SnackChannels.some((detail: any) => detail.SalesChannel === 'Conductor' && detail.IsActive === true))
      console.log('dataTemp', dataTemp)
      snackListByBuilding.value = dataTemp.map((item: any) => ({
        ...item,
        label: item.SnackName ?? '-',
        Image: item.SnackImage ? `${environment.getApiImageBaseUrl()}${changeImagePathPrefix(item.SnackImage)}` : defaulListImage,
        value: { ...item, label: item.SnackName ?? '-', Image: item.SnackImage ? `${environment.getApiImageBaseUrl()}${changeImagePathPrefix(item.SnackImage)}` : defaulListImage }
      }))
    }
  } catch (error) {
    console.log('err', error)
  }
  store.dispatch('hideLoading')
}

onMounted(async () => {
  // console.log('xxx', store.state?.userProfile?.resource_access['hjp-microservices'].roles.includes('Roster'))
  isRoster.value = store.state?.userProfile?.resource_access['hjp-microservices'].roles.includes('Roster')
  if (isRoster.value) {
    await setBuildingData()
  } else {
    isLoading.value = false
  }
  dataHeader.value = encryptDecriptMethods.decrypt(route.params.id)
  // console.log('header', dataHeader.value)
  checkAssignedSnack()
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Roster',
      routeName: 'roster'
    },
    {
      title: `PP${dataHeader.value.PpOrder} (${moment(dataHeader.value.RosterDate).format('HH:mm')})`,
      routeName: 'roster'
    },
    {
      title: 'Atur Snack',
      routeName: 'roster-snack',
      params: { id: route.params.id }
    }
  ])
})

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
        }, [
          _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table roster-main" }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
                    content: _withCtx(() => [
                      _hoisted_4,
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _hoisted_7,
                          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(dataHeader)?.RegNumber), 1)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _hoisted_10,
                          _createElementVNode("div", _hoisted_11, _toDisplayString(`Trayek ${_unref(dataHeader)?.TrayekClassName} | ${_unref(dataHeader)?.IsTol ? 'Tol' : 'Non Tol'} | ${_unref(dataHeader)?.TrayekName}`), 1)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("div", _hoisted_14, _toDisplayString(`PP${_unref(dataHeader)?.PpOrder} / ${_unref(moment)(_unref(dataHeader)?.RosterDate).format('HH:mm')}`), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          (!isRoster.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Pilih gudang tempat snack tersebut akan diambil"))
                            : _createCommentVNode("", true)
                        ]),
                        (isRoster.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(values).buildingData?.label), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createVNode(_unref(Field), { name: "buildingData" }, {
                                default: _withCtx(({ field, handleChange, handleBlur }) => [
                                  _createVNode(SelectAsyncOpen, {
                                    placeholder: 'Pilih Gedung',
                                    modelValue: _unref(values).buildingData,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(values).buildingData) = $event)),
                                    id: 'building',
                                    inputId: 'building',
                                    endpoint: "/talent/v1/Buildings",
                                    classname: 'custom-select',
                                    disabled: false,
                                    searchCustom: [['isActive', '=', 'true']],
                                    fieldLabel: (v) => `${v.name}`,
                                    clearable: false,
                                    searchFields: ['name']
                                  }, null, 8, ["modelValue", "fieldLabel"])
                                ]),
                                _: 1
                              })
                            ]))
                      ]),
                      (isShowFormList.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("div", _hoisted_23, [
                              _createVNode(_unref(FieldArray), { name: "data" }, {
                                default: _withCtx(({ fields, push, remove, replace }) => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (data, index) => {
                                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                                      _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("div", _hoisted_25, [
                                          _createVNode(_unref(Field), {
                                            name: `data[${index}].snackData`
                                          }, {
                                            default: _withCtx(({ field, handleChange, handleBlur }) => [
                                              _createVNode(_unref(Dropdown), {
                                                modelValue: field.value,
                                                onChange: (e) => handleChange(e.value),
                                                options: _unref(snackListByBuilding),
                                                filter: "",
                                                optionLabel: "label",
                                                optionValue: "value",
                                                placeholder: "Pilih Snack",
                                                class: "w-full md:w-14rem"
                                              }, {
                                                value: _withCtx((slotProps) => [
                                                  (slotProps.value)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                        _createElementVNode("img", {
                                                          src: slotProps.value.Image,
                                                          alt: "img",
                                                          class: "rounded-lg",
                                                          style: {"width":"60px"}
                                                        }, null, 8, _hoisted_27),
                                                        _createElementVNode("div", null, [
                                                          _createElementVNode("div", _hoisted_28, _toDisplayString(slotProps.value.SnackName), 1),
                                                          _createElementVNode("div", _hoisted_29, _toDisplayString(`${_unref(rupiahFormat)(slotProps.value.SnackFinalPrice ?? 0)} / pack | stock: ${_unref(numberFormat)(slotProps.value.AvailableSnackStock ?? 0)}`), 1)
                                                        ])
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(slotProps.placeholder), 1))
                                                ]),
                                                option: _withCtx((slotProps) => [
                                                  _createElementVNode("div", _hoisted_31, [
                                                    _createElementVNode("img", {
                                                      src: slotProps.option.Image,
                                                      alt: "img",
                                                      class: "rounded-lg",
                                                      style: {"width":"60px"}
                                                    }, null, 8, _hoisted_32),
                                                    _createElementVNode("div", null, [
                                                      _createElementVNode("div", _hoisted_33, _toDisplayString(slotProps.option.SnackName), 1),
                                                      _createElementVNode("div", _hoisted_34, _toDisplayString(`${_unref(rupiahFormat)(slotProps.option.SnackFinalPrice ?? 0)} / pack | stock: ${_unref(numberFormat)(slotProps.option.AvailableSnackStock ?? 0)}`), 1)
                                                    ])
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "onChange", "options"])
                                            ]),
                                            _: 2
                                          }, 1032, ["name"])
                                        ]),
                                        _createElementVNode("div", _hoisted_35, [
                                          _createVNode(_unref(Field), {
                                            name: `data[${index}].qty`,
                                            class: _normalizeClass(`input-primary`)
                                          }, {
                                            default: _withCtx(({ field }) => [
                                              _createElementVNode("div", _hoisted_36, [
                                                _createVNode(_unref(InputNumber), {
                                                  modelValue: field.value as number,
                                                  placeholder: "0",
                                                  min: 0,
                                                  locale: "id-ID",
                                                  step: 1,
                                                  inputId: "refund-amount",
                                                  allowEmpty: false,
                                                  autocomplete: "off",
                                                  "onUpdate:modelValue": field.onChange
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                _hoisted_37
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["name"])
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("img", {
                                            src: _imports_1,
                                            alt: "delete",
                                            class: "cursor-pointer",
                                            style: {"width":"35px","height":"35px"},
                                            onClick: ($event: any) => (remove(index))
                                          }, null, 8, _hoisted_38)
                                        ])
                                      ]),
                                      _createVNode(_unref(ErrorMessage), {
                                        class: "invalid-feedback",
                                        name: `data[${index}].qty`
                                      }, null, 8, ["name"])
                                    ]))
                                  }), 128)),
                                  _createElementVNode("div", _hoisted_39, [
                                    _createVNode(_unref(Button), {
                                      class: "flex gap-2 extra-submit-button",
                                      type: "button",
                                      outlined: true,
                                      onClick: ($event: any) => (push(defaultList()))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_40
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _hoisted_44,
                        (_unref(rosterSnackList).length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_48))
                          : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rosterSnackList), (dataSummary, index) => {
                                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                                    dataSummary
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_52, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("img", {
                                                  src: dataSummary.Image,
                                                  class: "rounded-lg",
                                                  alt: "snackImg",
                                                  style: {"width":"60px"}
                                                }, null, 8, _hoisted_53)
                                              ]),
                                              _createElementVNode("div", _hoisted_54, [
                                                _createElementVNode("div", _hoisted_55, _toDisplayString(dataSummary.SnackName), 1),
                                                _createElementVNode("div", _hoisted_56, _toDisplayString(`${_unref(rupiahFormat)(dataSummary.SnackFinalPrice)}/pack`), 1)
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_57, _toDisplayString(`${_unref(numberFormat)(dataSummary.Quantity)} Pack`), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]),
                              _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("div", null, [
                                  _hoisted_59,
                                  _createElementVNode("div", _hoisted_60, _toDisplayString(_unref(rupiahFormat)(rosterSnackData.value.SnackItemAmount ?? 0)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_61, _toDisplayString(`${_unref(numberFormat)(rosterSnackData.value.SnackItemCount ?? 0)} Pack`), 1)
                              ])
                            ]))
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createVNode(_unref(Button), {
                  class: "btn-back mr-2",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (toPrevPage()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_63
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  type: "submit",
                  id: "Submit",
                  class: "btn-primary mr-1"
                }, {
                  default: _withCtx(() => [
                    _hoisted_64
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ], 32)
      ]))
    : _createCommentVNode("", true)
}
}

})